import { render } from "./ProjectDetail.vue?vue&type=template&id=2aa000ea&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=2aa000ea&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa000ea"]])

export default __exports__